import { ReactNode } from 'react';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, TopicToDiscussStepData } from '@packages/shared/core/quiz/entities';

type TopicToDiscussQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const TopicToDiscussQuizStep = ({ id, renderQuizScreen }: TopicToDiscussQuizStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();
  const { next, stepData, updateUserPreferences, back } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey, otherClickEvent, otherOpenEvent } = stepData as TopicToDiscussStepData;

  const onChosen = (value: string) => {
    updateUserPreferences(dataKey, value);
    updateUserPreferences('goal', value);
    next(value);
  };

  const sendCustomAnswer = (value: string) => {
    analyticsService.trackQuizEvent(otherClickEvent, { context: value });
    next();
  };

  const onOtherClick = () => {
    analyticsService.trackQuizEvent(otherOpenEvent, {});
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        sendCustomAnswer,
        onOtherClick,
        goBack: back,
        ...(stepData as TopicToDiscussStepData),
      })}
    </>
  );
};

export default TopicToDiscussQuizStep;
